import Bouncer from 'formbouncerjs';
import {
  isFormProcessing,
  markFormProcessing,
  feedbackErr,
  feedback,
  feedbackClear,
  grecaptchaV3Execute,
  logToPHP,
  glsAjax,
} from './scripts';
import {
  subscribeToEveryAction,
  wantsOptIn,
} from './ea';

const $j = jQuery.noConflict();

function clearContactForm(submittingForm) {
  submittingForm.find('input').val('');
  submittingForm.find('[name="enews"]').prop('checked', false);
}

function hideContactForm(submittingForm) {
  submittingForm.find('.contact-info').hide();
  submittingForm.find('button[name="subscribe"]').hide();
}

async function processContactForm(submittingForm) {
  let enews = '0';
  let blog = '0';

  if (wantsOptIn(submittingForm, 'enews')) {
    enews = '1';
  }

  if (wantsOptIn(submittingForm, 'blog')) {
    blog = '1';
  }

  let response;
  const data = {
    action: 'contact_form_submit',
    first: submittingForm.find('[name="first"]').val(),
    last: submittingForm.find('[name="last"]').val(),
    email: submittingForm.find('[name="email"]').val(),
    message: submittingForm.find('[name="message"]').val(),
    enews,
    blog,
  };

  try {
    response = await glsAjax({ data });
  } catch (err) {
    logToPHP(`contact_form_submit ajax error. ${JSON.stringify(err)}`);
    feedbackErr(submittingForm, 'Sorry, there was an error processing your submission. Please try again another time.');
    markFormProcessing(submittingForm, false);
    return;
  }

  if (!response.success) {
    feedbackErr(submittingForm, 'Sorry, there was an error processing your contact form submission. Please try again later.');
    logToPHP(`error processing processContactForm: ${response.msg}`);
    return;
  }

  if (!response.success) {
    feedbackErr(submittingForm, response.msg);
    markFormProcessing(submittingForm, false);
    return;
  }

  let eaResponse;

  try {
    eaResponse = await subscribeToEveryAction(submittingForm);
  } catch (err) {
    feedbackErr(submittingForm, 'Your contact form submission succeeded, but there was an error with your subscription.');
    logToPHP(`subscribeToEveryAction error: ${JSON.stringify(err)}`);
    markFormProcessing(submittingForm, false);
    return;
  }

  if (eaResponse.success) {
    feedback(submittingForm, eaResponse.msg);
  }

  feedback(submittingForm, response.msg);
  markFormProcessing(submittingForm, false);
  hideContactForm(submittingForm);
}

$j(() => {
  const bouncer = new Bouncer('#contact-form', {
    disableSubmit: true,
  });

  $j('#contact-form').find('button[name="subscribe"]').click(async function handleSubscribeClick(event) {
    event.preventDefault();
    const submittingForm = $j(this).closest('form');

    if (isFormProcessing(submittingForm)) {
      feedbackErr(submittingForm, 'Hold on, still processing&hellip;');
      return;
    }

    markFormProcessing(submittingForm, true);
    $j(this).blur();
    feedbackClear(submittingForm);
    const arrayOfInvalidElements = bouncer.validateAll(submittingForm[0]); // [0] gets htmlelements

    if (
      !Array.isArray(arrayOfInvalidElements)
      || arrayOfInvalidElements.length > 0
    ) {
      markFormProcessing(submittingForm, false);
      return;
    }

    feedback(submittingForm, 'Processing form&hellip;');
    const gaction = 'contact_submit';
    const gresponse = await grecaptchaV3Execute(gaction);

    if (
      !Object.prototype.hasOwnProperty.call(gresponse, 'success')
      || !gresponse.success
    ) {
      feedbackErr(submittingForm, 'Sorry. There was a problem processing your contact form submission.');
      markFormProcessing(submittingForm, false);
      clearContactForm(submittingForm);
      return;
    }

    await processContactForm(submittingForm);
  });
});
